import type { DeviceType } from './device-type'

export enum TODOLIST_TASK_STATUS {
  DONE = 'done',
  IN_PROGRESS = 'in_progress',
  PENDING = 'pending',
  SKIPPED = 'skipped',
}

export interface ITodolistTaskGroup {
  name: string
  user_ids: string[]
}

export interface ITodolistTask extends IDBContextExtendedV2 {
  description: string
  executed_at: number | null
  executed_by: string
  groups: ITodolistTaskGroup[]
  mattermost_posts: string[]
  previous_tasks: string[]
  status: TODOLIST_TASK_STATUS
  template_id: string
  template_task_id: string
  title: string
  todo_list_id: string
}

export interface ITodolist extends IDBContextExtendedV2 {
  app_key: string
  device_type: DeviceType
  groups: ITodolistTaskGroup[]
  id: string
  template_id: string
  title: string
}

export interface ITodolistFlow {
  tasks: ITodolistTask[]
  todolist: ITodolist
}
